var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PureAlert',{attrs:{"id":_vm.id,"alert":_vm.alert},on:{"alert-hidden":_vm.resetAlert}})}
var staticRenderFns = []

export { render, staticRenderFns }